import * as React from "react";
import { CentralizedDrawer } from "@wtc/ui";
import { ResponsiveCommandMultiSelectList } from "./ResponsiveCommandMultiSelectList";

interface ResponsiveCommandMultiSelectMobileProps {
  drawerId: string;
  title: string;
  description?: string;
  trigger: React.ReactNode;
  listProps: React.ComponentProps<typeof ResponsiveCommandMultiSelectList>;
}

export function ResponsiveCommandMultiSelectMobile({
  drawerId,
  title,
  description,
  trigger,
  listProps,
}: ResponsiveCommandMultiSelectMobileProps) {
  return (
    <>
      {trigger}
      <CentralizedDrawer
        drawerId={drawerId}
        side="bottom"
        title={title}
        description={description}
        showCloseButton={true}
        enableSwipeGesture={true}
      >
        <div className="flex-1 overflow-y-auto p-4">
          <div className="mt-4 border-t p-2">
            <ResponsiveCommandMultiSelectList {...listProps} />
          </div>
        </div>
      </CentralizedDrawer>
    </>
  );
}
